import React, { useEffect, useState } from "react";
import { MainLayout } from "../../../layout/MainLayout";
import { Button } from "../../../UI/MUIButton";
import { CreatePortfolioModal } from "../network_settings/modals/CreatePortfolioModal";
import useAuth from "../../login/AuthContext";
import { LoadAllPortfolios, Portfolio } from "../../../services/PortfolioApi";
import { useHistory } from "react-router";
import { PORTFOLIO_DETAILED } from "./PortfolioDetailedView";
import { Grid } from "../../../UI/Grid";
import { Table } from "../../../UI/Table";
import { TableHead } from "../../../UI/TableHead";
import { TableRow } from "../../../UI/TableRow";
import { TableCell } from "../../../UI/TableCell";
import { StyledTableRow } from './sharedElements';
import { handleNavigation } from "../../../helpers/handleNavigation";

export const PortfolioList: React.FunctionComponent = () => {
  const { isWriteAccess, getAuthToken } = useAuth();
  const [portfolios, setPortfolios] = useState<Portfolio[]>([]);
  const [isPortfolioCreationModal, setIsPortfolioCreationModal] = useState<boolean>(false);

  useEffect(() => {
    const load = async () => {
      const results = await LoadAllPortfolios(0, await getAuthToken());

      if (results?.content) {
        setPortfolios(results?.content);
      }
    };

    load();
  }, []);

  return (
    <MainLayout
      title="Portfolios"
      endAdornment={isWriteAccess() && (
        <>
          <Button color="primary" variant="contained" onClick={() => setIsPortfolioCreationModal(true)}>
            Create a new portfolio
          </Button>
          <CreatePortfolioModal show={isPortfolioCreationModal}
            onClose={() => setIsPortfolioCreationModal(false)} />
        </>
      )}
    >
      {isWriteAccess() && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Contact Url</TableCell>
                </TableRow>
              </TableHead>
              {portfolios.map(portfolio => <PortfolioRow key={portfolio.id} portfolio={portfolio} />)}
            </Table>
          </Grid>
        </Grid>
      )}
    </MainLayout>
  );
};

interface PortfolioRowProps {
  portfolio: Portfolio
};

const PortfolioRow: React.FC<PortfolioRowProps> = ({ portfolio }) => {
  const { push } = useHistory();

  const handleClick = (event: React.MouseEvent) => {
    handleNavigation(event, PORTFOLIO_DETAILED.replace(":portfolioId", portfolio.id), push);
  };

  return (
    <StyledTableRow onClick={handleClick}>
      <TableCell>{portfolio.name}</TableCell>
      <TableCell>{portfolio.contactUrl}</TableCell>
    </StyledTableRow>
  );
};


export const PORTFOLIO_LIST = "/super_admin/portfolios";